export interface ILang {
	[key: string]: {
		text: string;
		lng: 'pt-BR' | 'en';
		icon: string;
	};
}

const LANG: ILang = {
	PT_BR: {
		text: 'Português (BR)',
		lng: 'pt-BR',
		icon: 'CustomBrazil',
	},
	EN: {
		text: 'English',
		lng: 'en',
		icon: 'CustomUsa',
	},
};

export const getLangWithKey = (key: ILang['key']['lng']): ILang['key'] => {
	// @ts-ignore
	return LANG[Object.keys(LANG).filter((f) => key.includes(LANG[f].lng))];
};

export default LANG;
